// @flow

import type { TranslateFn } from '../../../hooks/locale.js';

const localizedFloorNumber = (number, t) => {
  const digits = Math.abs(number).toString().split('').reverse();
  if (digits[0] === '1') {
    return t('floorOne');
  } else if (digits[0] === '2') {
    return t('floorTwo');
  } else if (digits[0] === '3') {
    return t('floorThree');
  }
  return t('floorNth', { count: Number.parseFloat(digits[0]) });
};

export const nth = (number: number, t: TranslateFn): number | string => {
  if (!Number.isInteger(number)) {
    return number;
  }
  return localizedFloorNumber(number, t);
};
